import create from 'zustand';
import createStoreSelectors from '../utils/createStoreSelector';

const useStore = create((set) => ({
  isGroupNew: false,
  toggleIsGroupNew: (value) => {
    set((state) => ({
      ...state,
      isGroupNew: value
    }));
  }
}));

const useGroupsChangeStore = createStoreSelectors(useStore);

export default useGroupsChangeStore;
